module.exports = __webpack_public_path__ + "img/clochette-grise.411000cc.png";